module.exports = __webpack_public_path__ + "static/media/dark-theme-alerts.1cf802df.svg";